module.exports = __webpack_public_path__ + "static/media/48.23dce778.jpg";